export default __webpack_public_path__ + "static/media/others.ca55ccd9.jpg";